module.exports = __webpack_public_path__ + "img/prioritas_interpackmaxi_dfod_k.a07c4946.png";